import {Load} from "./Load";
import {Basic} from "./Basic";

export class Observer
{
    constructor(el)
    {
        el.dataset.autoload = '';
        this.targetContainer = el;
        this.observer = new IntersectionObserver(this.load_more.bind(this));
        this.start_observing();
    }

    start_observing()
    {
        let lastChild = this.targetContainer.lastChild;
        this.observer.observe(lastChild);
    }

    load_more(e)
    {
        if(e[0].isIntersecting === true)
        {
            this.observer.unobserve(e[0].target);

            Load.post({
                f: 'load-more',
                filters: this.targetContainer.dataset.filters ? JSON.parse(decodeURIComponent(this.targetContainer.dataset.filters)) : {},
                remember: this.targetContainer.dataset.remember,
                start: parseInt(this.targetContainer.dataset.start),
                target: this.targetContainer.dataset.target
            }).then(r => {
                // insert new html
                this.targetContainer.insertAdjacentHTML('beforeend', r['html'].toString());
                Basic.do_afterLoad();

                // add new autoload data
                if(r['autoload'])
                {
                    this.targetContainer.dataset.start = r['start'].toString();
                    if(r['remember'])
                    {
                        this.targetContainer.dataset.remember = r['remember'].toString();
                    }
                    this.start_observing();
                }
            }).catch(error => {
                console.error(error);
            })
        }
    }
}